class ModalService {
  constructor() {
    this.modalList = [];
    this.listeners = [];
  }

  addModal(modalTemplate, modalParam, callBackFunc) {
    if (document.activeElement) {
      document.activeElement.blur();
    }
    document.body.style.overflow = 'hidden';
    this.modalList.push({ modalTemplate, modalParam, callBackFunc });
    this.notifyListeners();
  }

  removeModal(modalTemplate) {
    this.modalList = this.modalList.filter(
      item => item.modalTemplate !== modalTemplate
    );
    // 모달이 모두 제거되면 스크롤을 다시 허용
    if (this.modalList.length === 0) {
      document.body.style.overflow = 'auto';
    }

    this.notifyListeners();
  }

  clearModals() {
    this.modalList = [];
    document.body.style.overflow = 'auto'; // 스크롤을 다시 허용

    this.notifyListeners();
  }

  subscribe(listener) {
    this.listeners.push(listener);
  }

  unsubscribe(listener) {
    this.listeners = this.listeners.filter(l => l !== listener);
  }

  notifyListeners() {
    this.listeners.forEach(listener => listener(this.modalList));
  }

  errorAlert(msg, callBackFunc) {
    this.addModal('ErrorAlert', msg, callBackFunc);
  }
  noticeAlert(msg, callBackFunc) {
    this.addModal('NoticeAlert', msg, callBackFunc);
  }
  successAlert(msg, callBackFunc) {
    this.addModal('SuccessAlert', msg, callBackFunc);
  }
  confirmAlert(msg, callBackFuncList) {
    this.addModal('ConfirmAlert', msg, callBackFuncList);
  }

  openModal(modalTemplate, modalParam, callBackFunc) {
    this.addModal(modalTemplate, modalParam, callBackFunc);
  }
}

export default ModalService;
